import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import './media.css';
import HeaderComponent from './HeaderComponent';
// import NavigationComponent from './NavigationComponent';
import FooterComponent from './FooterComponent';
import Routes from '../routes/Routes';
import { registerAuthListener, doLogOut } from '../api/userManagement';
import Fab from '@material-ui/core/Fab';
import PersonIcon from '@material-ui/icons/Person';
import ShareIcon from '@material-ui/icons/Room';
import Dialog from '../components/DialogComponent'
import Button from '@material-ui/core/Button';

class AppComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserLogged: 'unknown',
      username: 'user',
      isDialogOpen: false,
      dialogContent: null
    };
  }

  componentDidMount() {
    registerAuthListener(this);
  }

  handleDialogOpen = (content) => {
    this.setState({
      isDialogOpen: true,
      dialogContent: content
    });
  }

  handleDialogClose = () => {
    this.setState({
      isDialogOpen: false
    });
  };

  render() {
    let logButton, userProfileMenuButton, dialogWindow;
    if (this.state.isDialogOpen) dialogWindow = <Dialog isOpen={this.state.isDialogOpen} handleClose={this.handleDialogClose} contentId={this.state.dialogContent} />
    else dialogWindow = null;
    if (this.state.isUserLogged === true) {
      userProfileMenuButton =
        <Fab variant="extended" onClick={() => this.handleDialogOpen('ProfileDialog')} id="AuthPrimaryButton">
          <PersonIcon className="material-icon" />
          <span className="usernameLabel">{this.state.username}</span>
        </Fab>

      logButton =
        <Button onClick={() => doLogOut()} id="AuthSecondaryButton">
          <span>Log out</span>
        </Button>

    } else if (this.state.isUserLogged === false) {
      userProfileMenuButton =
        <Fab variant="extended" onClick={() => this.handleDialogOpen('LoginDialog')} id="AuthPrimaryButton">
          <PersonIcon className="material-icon" />
          <span className="loginLabel">Log in</span>
        </Fab>

      logButton =
        <Button onClick={() => this.handleDialogOpen('RegisterDialog')} id="AuthSecondaryButton">
          <span>Register</span>
        </Button>

    }
    return (
      <Router id="app">
        <div id="app">
          <header>
            <HeaderComponent />
            {/* <NavigationComponent /> */}
            <nav>
              <div id="MenuColumn">
                <Fab variant="extended" color="primary" onClick={() => this.handleDialogOpen('ShareDialog')} id="ShareFab">
                  <ShareIcon className="material-icon" />
                  Share your memories
                </Fab>
              </div>
              <div id="AuthColumn">
                {userProfileMenuButton}
                {logButton}
              </div>
            </nav>
          </header>
          <main>
            <Routes />
          </main>
          <footer onClick={() => this.handleDialogOpen('InfoDialog')}>
            <FooterComponent />
          </footer>
          {dialogWindow}
        </div>
      </Router >
    );
  }
}

export default AppComponent;
